export default __webpack_public_path__ + "static/media/instareports.315c1032.svg";